import { ApiAddress } from "@/services/apis"
import request from "@/services/request"

export declare module FlowSheet {
  export interface Modal {
    id: number
    name: string
    description: string
    content?: string
    template?: number
    tempContent?: string
  }

}

export function createFlowSheetFile(pId: string, body): Promise<FlowSheet.Modal> {
  return request.post(ApiAddress.FLOWSHEETS, body, {params:{pId}})
}

export function updateFlowSheetFile(body, params): Promise<FlowSheet.Modal> {
  return request.put(ApiAddress.FLOWSHEET, body, {params})
}

export function getFlowFiles(pId: string): Promise<FlowSheet.Modal[]> {
  return request.get(ApiAddress.FLOWSHEETS, {params:{pId}})
}

export async function getFlowFile(id: string): Promise<FlowSheet.Modal> {
  const flowfile: FlowSheet.Modal = await request.get(ApiAddress.FLOWSHEET, {params:{id}})
  if (flowfile.template) {
    const template = await getFSTemplate(flowfile.template)
    if (template && template.content) {
      flowfile.tempContent = template.content
    }
  }
  return flowfile
}

export function deleteFlowFile(id: number): Promise<FlowSheet.Modal> {
  return request.delete(ApiAddress.FLOWSHEET, {params:{id}})
}

export function getTemplates(pId: string): Promise<FlowSheet.Modal[]> {
  return request.get(ApiAddress.FS_TEMPLATES, {params:{pId}})
}

export function getFSTemplate(id: number | string): Promise<FlowSheet.Modal> {
  return request.get(ApiAddress.FS_TEMPLATE, {params:{id}})
}

export function createTemplate(body, pId: string): Promise<FlowSheet.Modal[]> {
  return request.post(ApiAddress.FS_TEMPLATES, body, {params:{pId}})
}

export function updateTemplate(body, params): Promise<FlowSheet.Modal> {
  return request.put(ApiAddress.FS_TEMPLATE, body, {params})
}

export function deleteTemplate(id: number): Promise<FlowSheet.Modal> {
  return request.delete(ApiAddress.FS_TEMPLATE, {params:{id}})
}